$shm_wordstat_filter_section $mol_list
	title \
	title_content /
		<= title
	content /
	rows <= section_rows /
	Title $mol_view
		sub /
			<= Expand $mol_check_expand
				checked? <=> expanded? true
				expandable true
			<= Label $mol_view
				sub <= title_content
